import CAOA1030ResponseModel from '@/api/data/CAO/CAOG1030/CAOG1030ResponseModel'

import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

// @ts-ignore
import { qaInfoLst, catInfoLst } from './CAOG1030ViewModel'

export default class CAOG1030Service {
  /**
   * CAOA1030 API呼出処理
   * @returns Object
   */
  public async callAPICAAOA1030(): Promise<CAOA1030ResponseModel> {
    const caoa1030ResponseModel: CAOA1030ResponseModel = <
      CAOA1030ResponseModel
    > await RestService.post(ApiUrlConstants.CAOA1030, {})
    return caoa1030ResponseModel
  }

  /**
   * カテゴリ名情報取得
   * @param searchCategoryId
   * @param catInfoLstData
   * @returns string
   */
  public getCategoryNameById(
    searchCategoryId: number,
    catInfoLstData: Array<catInfoLst>
  ): string {
    let searchCategory = ''
    catInfoLstData.forEach((x) => {
      if (x.classId === searchCategoryId) {
        searchCategory = x.classMei
      }
    })

    return searchCategory
  }

  /**
   * 質問一覧フィルタ
   * @param searchCategoryId
   * @param qaInfoLstData
   * @param searchKeyword
   * @returns Array
   */
  public filterQuestion(
    searchCategoryId: number,
    qaInfoLstData: Array<qaInfoLst>,
    searchKeyword: string
  ): Array<qaInfoLst> {
    let faqFilterCategoryLst: qaInfoLst[] = []
    let faqFilterLst: qaInfoLst[] = []

    if (searchCategoryId) {
      const qaInfo = Object.values(qaInfoLstData || {}).filter(
        (x) => x.classId === searchCategoryId
      )
      faqFilterCategoryLst.push(...qaInfo)
    } else {
      faqFilterCategoryLst = JSON.parse(JSON.stringify(qaInfoLstData))
    }

    if (searchKeyword && faqFilterCategoryLst) {
      faqFilterCategoryLst.forEach((x) => {
        if (
          x?.title?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
          x?.memo?.toLowerCase().includes(searchKeyword.toLowerCase())
        ) {
          faqFilterLst.push(x)
        }
      })
    } else {
      faqFilterLst = JSON.parse(JSON.stringify(faqFilterCategoryLst))
    }

    return faqFilterLst?.map((item) => {
      item.id = Math.random().toString()
      return {
        ...item
      }
    })
  }
}
